import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Div Block',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          flexBasis: px(320),
          flexGrow: 0,
          flexShrink: 0,
          position: 'sticky',
          top: px(20),
        },
      },
      small: {
        noPseudo: {
          flexBasis: 'auto',
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
